/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncTopicRangesRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {SyncTopicRangesResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const syncTopicRanges = (request:SyncTopicRangesRequest, options?: CashRequestOptions) => post<SyncTopicRangesRequest, SyncTopicRangesResponse>("/2.0/cash/sync-topic-ranges", request, {...options, rejectOnError: true })